/**
 * Particle gradient mode.
 */
export enum ParticleGradientMode {
  /* Single constant color. */
  Constant,
  /* Random value between two constant colors. */
  TwoConstants,
  /* Single color gradient curve mode. */
  Gradient,
  /* Random value between two color gradients. */
  TwoGradients
}
